import 'popper.js/dist/umd/popper.min';
import 'select2/dist/js/select2.full';
